import { getJSONValue } from '../../../../../utils/local-storage'

export default {
  computed: {
    draftLocalStorageKey() {
      const parentType = this.id ? 'edit' : 'new'
      const subpath = this.id
        ? `remark/${this.id}`
        : `${this.ownerType}/${this.ownerId}`

      return `remarkDraft/${parentType}/${this.ledgerId}/${subpath}`
    },
  },
  methods: {
    loadDraft() {
      const valueWithTTL = getJSONValue(this.draftLocalStorageKey)

      if (valueWithTTL) {
        return valueWithTTL.value
      }

      return null
    },
  },
}
